import React from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Box,
  Chip
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import { BCPCalendarDay } from "../icons/bcp/BCPIcons";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { getTokenStatusColor } from "../utilities/CircuitTokenUtils";

const SYSTEM_IMAGES_CLOUDFRONT = getEnvironmentVariable(
  "SYSTEM_IMAGES_CLOUDFRONT"
);

export default function CircuitTokenCard({ token, eventDetail }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "components.CircuitTokenCard"
  });
  const navigate = useNavigate();

  const circuitName = token?.league?.name || token?.name || "Unnamed Circuit";
  const gameSystemName =
    token?.league?.gameSystem?.name || token?.gameSystem?.name || "Game System";
  const status = token?.status || "unknown";
  const eventName = eventDetail?.name || token?.event?.name;

  const handleCardClick = () => {
    navigate("/organize/tokens");
  };

  return (
    <Card
      onClick={handleCardClick}
      sx={{
        height: "100%",
        bgcolor: "background.paper",
        borderRadius: 2,
        cursor: "pointer",
        transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: 3
        },
        "& .MuiCardContent-root": {
          p: 2
        }
      }}
    >
      <CardMedia
        component="img"
        height="200"
        image={`${SYSTEM_IMAGES_CLOUDFRONT}/images/header.jpg`}
        alt={circuitName}
        sx={{
          objectFit: "cover",
          objectPosition: "center"
        }}
      />
      <CardContent>
        <Box sx={{ mb: 2 }}>
          <Typography
            variant="h5"
            component="div"
            gutterBottom
            noWrap
            fontWeight="700"
          >
            {circuitName}
          </Typography>
          <Typography variant="h6" gutterBottom>
            {gameSystemName}
          </Typography>
        </Box>

        <Box sx={{ mb: 2 }}>
          <Chip
            label={t(status, {
              keyPrefix: "pages.dashboards.organize",
              defaultValue: status
            })?.toUpperCase()}
            size="small"
            color={getTokenStatusColor(status)}
            sx={{ fontWeight: 600 }}
          />
        </Box>

        <Box sx={{ mb: 1 }}>
          <Typography variant="caption" color="text.secondary">
            {t("tokenCreated")}: {moment(token?.created_at).format("LL")}
          </Typography>
        </Box>

        {eventName && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <BCPCalendarDay sx={{ fontSize: 20, color: "text.secondary" }} />
            <Typography variant="body2" color="text.secondary">
              {t("event")}: {eventName}
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
}
